var Y = (f, k, P) => new Promise((b, d) => {
  var m = (y) => {
    try {
      g(P.next(y));
    } catch (_) {
      d(_);
    }
  }, r = (y) => {
    try {
      g(P.throw(y));
    } catch (_) {
      d(_);
    }
  }, g = (y) => y.done ? b(y.value) : Promise.resolve(y.value).then(m, r);
  g((P = P.apply(f, k)).next());
});
import { c as l, e as o, G as ze, a as I, u as ae, h as i, w as h, g as u, x as K, am as Me, j as Be, k as c, ao as C, m as W, v as s, q as ee, o as Ne, b as $e, f as t, t as z, l as j, F as R, n as F, z as Ue, al as we, i as E, p as Ve, an as oe } from "./define-element-XpjsV6s1.js";
import { u as Re, L as de, C as Ee } from "./use-payment-CcwDaLQz.js";
import { u as Ie } from "./use-addresses-Wp77HwbF.js";
import { u as Te } from "./use-user-CwEHAZOt.js";
import { u as We } from "./use-cart-D8NOb7eE.js";
import { f as Fe, p as Le, S as De, c as Ge } from "./StripePaymentForm-CDVtd19T.js";
import { A as Oe } from "./Accordion-ETC-82Nb.js";
import { A as qe } from "./Address-QnUa_uo4.js";
import { B as T } from "./Button-D5lKR5Sd.js";
import { _ as te } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { o as je } from "./index-D_t0kTBY.js";
import { _ as B } from "./Icon-CGbhZCm-.js";
import { I as re } from "./Input-yplyeePD.js";
import { c as ve, m as pe } from "./utils-CMsllPx8.js";
const Ke = /* @__PURE__ */ Object.assign({ inheritAttrs: !1 }, {
  __name: "Radio",
  setup(f) {
    return (k, P) => (l(), o("input", ze({
      class: "offset-radio",
      type: "radio"
    }, k.$attrs), null, 16));
  }
}), L = /* @__PURE__ */ te(Ke, [["__scopeId", "data-v-bcd5ad73"]]), Ze = {
  class: "offset-edit-button-menu-container",
  ref: "container"
}, He = {
  __name: "EditButtonMenu",
  setup(f) {
    const k = I(!1), P = ae("container"), b = ae("trigger");
    je(P, () => k.value = !1);
    function d() {
      var m, r;
      k.value = !1, (r = (m = b.value) == null ? void 0 : m.$el) == null || r.focus();
    }
    return (m, r) => (l(), o("div", Ze, [
      i(T, {
        ref: "trigger",
        class: "offset-edit-button-menu",
        "aria-label": "Edit options",
        "aria-haspopup": "true",
        "aria-expanded": k.value,
        onClick: r[0] || (r[0] = K((g) => k.value = !k.value, ["stop"]))
      }, {
        default: h(() => r[1] || (r[1] = [
          u("svg", {
            width: "12px",
            height: "12px",
            viewBox: "0 0 16 16"
          }, [
            u("path", { d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" })
          ], -1)
        ])),
        _: 1,
        __: [1]
      }, 8, ["aria-expanded"]),
      k.value ? (l(), o("div", {
        key: 0,
        class: "offset-edit-button-menu-dropdown",
        onKeydown: Me(d, ["esc"])
      }, [
        Be(m.$slots, "default", {}, void 0, !0)
      ], 32)) : c("", !0)
    ], 512));
  }
}, Je = /* @__PURE__ */ te(He, [["__scopeId", "data-v-729d96a6"]]), Qe = { ref: "container" }, Xe = {
  key: 0,
  class: "offset-checkout-payment-info"
}, Ye = {
  key: 1,
  class: "offset-checkout-payment-info"
}, ea = ["textContent"], aa = { class: "offset-checkout-payment-info" }, ta = { class: "offset-checkout-payment-info" }, la = {
  key: 2,
  class: "offset-checkout-payment-divider"
}, sa = {
  key: 1,
  class: "offset-checkout-payment use-different"
}, na = {
  key: 2,
  class: "offset-checkout-use-shipping-address"
}, ia = { class: "grouped" }, ua = { class: "grouped" }, oa = { class: "offset-checkout-payment-info" }, da = { class: "offset-checkout-payment-info" }, ra = { class: "offset-checkout-payment-info" }, va = { class: "offset-checkout-payment use-different" }, pa = {
  __name: "CheckoutPayment",
  props: /* @__PURE__ */ oe({
    inheritStyle: {
      type: String,
      default: "all"
    },
    disableWallets: {
      type: Boolean,
      default: !1
    },
    shippingExempt: {
      type: Boolean,
      default: !1
    }
  }, {
    first_name: {},
    first_nameModifiers: {},
    last_name: {},
    last_nameModifiers: {},
    address: {},
    addressModifiers: {},
    address_2: {},
    address_2Modifiers: {},
    city: {},
    cityModifiers: {},
    state: {},
    stateModifiers: {},
    zip: {},
    zipModifiers: {},
    country: {},
    countryModifiers: {},
    businessName: {},
    businessNameModifiers: {},
    editingPayment: { default: !1 },
    editingPaymentModifiers: {},
    addingPayment: { default: !1 },
    addingPaymentModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["paymentTypeChanged"], ["update:first_name", "update:last_name", "update:address", "update:address_2", "update:city", "update:state", "update:zip", "update:country", "update:businessName", "update:editingPayment", "update:addingPayment"]),
  setup(f, { emit: k }) {
    const P = k, b = f, d = I(null), m = C(f, "first_name"), r = C(f, "last_name"), g = C(f, "address"), y = C(f, "address_2"), _ = C(f, "city"), A = C(f, "state"), x = C(f, "zip"), N = C(f, "country"), $ = C(f, "businessName"), U = I(!0), le = W(() => !s(n.value)), fe = W(() => !b.shippingExempt), se = I(!1), Z = I(null), v = I({
      first_name: !1,
      last_name: !1,
      address: !1,
      city: !1,
      state: !1,
      zip: !1
    }), {
      data: w,
      isPending: me,
      hasPayments: ne,
      selectedPayment: S,
      deletePaymentMutation: ye
    } = Re(), D = C(f, "editingPayment"), G = C(f, "addingPayment"), { selectedAddress: n } = Ie(), { data: ie } = Te(), { cart: ce, selectPaymentForCart: H, isSelectingPaymentForCart: J } = We(), { isApplePayAvailable: Q, isGooglePayAvailable: X } = Fe();
    ee(
      w,
      (p) => {
        var a;
        if (!p || p.length === 0) return;
        const e = (a = ce.value) == null ? void 0 : a.config.payment_id;
        e ? p.some(
          (xe) => String(xe.id) === String(e)
        ) || H(p[0].id) : p.length === 1 && H(p[0].id);
      },
      { immediate: !0 }
    );
    function ge() {
      v.value.first_name = !1, v.value.last_name = !1, v.value.address = !1, v.value.city = !1, v.value.state = !1, v.value.zip = !1, s(m.value) && (v.value.first_name = !0), s(r.value) && (v.value.last_name = !0), s(g.value) && (v.value.address = !0), s(_.value) && (v.value.city = !0), s(A.value) && (v.value.state = !0), s(x.value) && (v.value.zip = !0);
    }
    function ke() {
      s(n.value) || (s(m.value) && (m.value = n.value.first_name), s(r.value) && (r.value = n.value.last_name), s(g.value) && (g.value = n.value.address), s(y.value) && (y.value = n.value.address_2), s(_.value) && (_.value = n.value.city), s(A.value) && (A.value = n.value.state), s(x.value) && (x.value = n.value.zip), s(N.value) && (N.value = n.value.country), s($.value) && ($.value = n.value.businessName));
    }
    function ue() {
      m.value = n.value.first_name, r.value = n.value.last_name, g.value = n.value.address, y.value = n.value.address_2, _.value = n.value.city, A.value = n.value.state, x.value = n.value.zip, N.value = n.value.country, $.value = n.value.businessName;
    }
    function _e() {
      return Y(this, null, function* () {
        var p, e, a;
        if (U.value && le.value)
          ue();
        else if (ge(), s(m.value) || s(r.value) || s(g.value) || s(_.value) || s(A.value) || s(x.value))
          return;
        J.value = !0;
        try {
          yield Ge({
            first_name: m.value,
            last_name: r.value,
            address: g.value,
            address_2: y.value,
            city: _.value,
            state: A.value,
            zip: x.value,
            country: N.value,
            businessName: $.value,
            email: ((p = n.value) == null ? void 0 : p.email) || ie.value.email,
            phone: ((e = n.value) == null ? void 0 : e.phone) || ((a = ie.value) == null ? void 0 : a.phone)
          });
        } catch (q) {
          Z.value = q;
        } finally {
          J.value = !1;
        }
      });
    }
    function be() {
      G.value = !0, D.value = !1, V(null);
    }
    function O(p) {
      G.value = !1, D.value = !1, V(p);
    }
    function Ce(p) {
      return Y(this, null, function* () {
        yield ye.mutate(p);
      });
    }
    function he() {
      G.value = !1, D.value = !1, V(null);
    }
    ee(n, () => {
      U.value && ke();
    }), ee(U, () => {
      le.value && ue();
    });
    function V(p) {
      d.value = p, P("paymentTypeChanged", p);
    }
    const Pe = W(() => d.value !== null && Le(d.value) === null), M = W(
      () => d.value === "apple_pay" || d.value === "google_pay"
    ), Se = W(() => !ne.value), Ae = ae("container");
    return Ne(() => {
      $e(Ae.value, b.inheritStyle);
    }), (p, e) => (l(), o("div", Qe, [
      i(Oe, {
        label: "Payment",
        opened: !t(ne),
        disabled: p.$attrs.disabled,
        class: "offset-checkout-payments"
      }, {
        disabled: h(() => e[16] || (e[16] = [])),
        closed: h(() => [
          M.value ? (l(), o("div", Xe, [
            i(B, { name: d.value }, null, 8, ["name"]),
            u("div", null, z(d.value === "apple_pay" ? "Apple Pay" : "Google Pay"), 1)
          ])) : t(S) ? (l(), o("div", Ye, [
            i(B, {
              name: t(ve)(t(S).credit_type)
            }, null, 8, ["name"]),
            u("div", null, z(t(pe)(t(S).credit_number)), 1),
            u("div", null, z(t(S).credit_expires_month) + "/" + z(t(S).credit_expires_year), 1)
          ])) : c("", !0)
        ]),
        opened: h(() => [
          t(s)(Z.value) ? c("", !0) : (l(), o("div", {
            key: 0,
            textContent: z(Z.value),
            class: "error",
            role: "alert"
          }, null, 8, ea)),
          t(me) ? (l(), j(de, {
            key: 1,
            label: "Loading Payments"
          })) : !t(w) || t(w).length === 0 || G.value || D.value ? (l(), o(R, { key: 2 }, [
            e[25] || (e[25] = u("em", null, "All transactions are secure and encrypted.", -1)),
            Se.value ? (l(), o(R, { key: 0 }, [
              t(Q) && !b.disableWallets ? (l(), o("label", {
                key: 0,
                class: F(["offset-checkout-payment", { active: d.value === "apple_pay" }])
              }, [
                i(L, {
                  name: "payment",
                  value: "apple_pay",
                  checked: d.value === "apple_pay",
                  onChange: e[0] || (e[0] = (a) => O("apple_pay"))
                }, null, 8, ["checked"]),
                u("div", aa, [
                  i(B, { name: "apple_pay" }),
                  e[17] || (e[17] = u("div", null, "Apple Pay", -1))
                ])
              ], 2)) : c("", !0),
              t(X) && !b.disableWallets ? (l(), o("label", {
                key: 1,
                class: F(["offset-checkout-payment", { active: d.value === "google_pay" }])
              }, [
                i(L, {
                  name: "payment",
                  value: "google_pay",
                  checked: d.value === "google_pay",
                  onChange: e[1] || (e[1] = (a) => O("google_pay"))
                }, null, 8, ["checked"]),
                u("div", ta, [
                  i(B, { name: "google_pay" }),
                  e[18] || (e[18] = u("div", null, "Google Pay", -1))
                ])
              ], 2)) : c("", !0),
              t(Q) || t(X) ? (l(), o("div", la, e[19] || (e[19] = [
                u("span", null, "OR", -1)
              ]))) : c("", !0)
            ], 64)) : c("", !0),
            Ue(i(De, { onPaymentTypeChanged: V }, null, 512), [
              [we, !M.value]
            ]),
            M.value ? (l(), o("div", sa, [
              i(T, {
                onClick: e[2] || (e[2] = (a) => V(null)),
                variant: "alt"
              }, {
                default: h(() => e[20] || (e[20] = [
                  E(" Enter card details instead ", -1)
                ])),
                _: 1,
                __: [20]
              })
            ])) : c("", !0),
            fe.value && !M.value ? (l(), o("label", na, [
              i(Ee, {
                modelValue: U.value,
                "onUpdate:modelValue": e[3] || (e[3] = (a) => U.value = a)
              }, null, 8, ["modelValue"]),
              e[21] || (e[21] = E(" Use shipping address as billing address ", -1))
            ])) : c("", !0),
            b.shippingExempt || !M.value && !U.value ? (l(), o(R, { key: 3 }, [
              e[22] || (e[22] = u("h3", null, "Billing Address", -1)),
              u("div", ia, [
                i(re, {
                  type: "text",
                  label: "First Name",
                  modelValue: m.value,
                  "onUpdate:modelValue": e[4] || (e[4] = (a) => m.value = a),
                  required: "",
                  invalid: v.value.first_name,
                  floating: !0
                }, null, 8, ["modelValue", "invalid"]),
                i(re, {
                  type: "text",
                  label: "Last Name",
                  modelValue: r.value,
                  "onUpdate:modelValue": e[5] || (e[5] = (a) => r.value = a),
                  required: "",
                  invalid: v.value.last_name,
                  floating: !0
                }, null, 8, ["modelValue", "invalid"])
              ]),
              i(qe, {
                country: N.value,
                "onUpdate:country": e[6] || (e[6] = (a) => N.value = a),
                address: g.value,
                "onUpdate:address": e[7] || (e[7] = (a) => g.value = a),
                address2: y.value,
                "onUpdate:address2": e[8] || (e[8] = (a) => y.value = a),
                city: _.value,
                "onUpdate:city": e[9] || (e[9] = (a) => _.value = a),
                state: A.value,
                "onUpdate:state": e[10] || (e[10] = (a) => A.value = a),
                zip: x.value,
                "onUpdate:zip": e[11] || (e[11] = (a) => x.value = a),
                company: $.value,
                "onUpdate:company": e[12] || (e[12] = (a) => $.value = a),
                invalidAddress: v.value.address,
                invalidCity: v.value.city,
                invalidState: v.value.state,
                invalidZip: v.value.zip
              }, null, 8, ["country", "address", "address2", "city", "state", "zip", "company", "invalidAddress", "invalidCity", "invalidState", "invalidZip"])
            ], 64)) : c("", !0),
            u("div", ua, [
              Pe.value ? (l(), j(T, {
                key: 0,
                onClick: K(_e, ["stop"]),
                disabled: se.value
              }, {
                default: h(() => e[23] || (e[23] = [
                  E(" Save ", -1)
                ])),
                _: 1,
                __: [23]
              }, 8, ["disabled"])) : c("", !0),
              t(w) && t(w).length > 0 ? (l(), j(T, {
                key: 1,
                onClick: K(he, ["stop"]),
                variant: "alt",
                disabled: se.value
              }, {
                default: h(() => e[24] || (e[24] = [
                  E("Cancel", -1)
                ])),
                _: 1,
                __: [24]
              }, 8, ["disabled"])) : c("", !0)
            ])
          ], 64)) : (l(), o(R, { key: 3 }, [
            t(J) ? (l(), j(de, {
              key: 0,
              label: "Loading Payments"
            })) : (l(), o(R, { key: 1 }, [
              t(Q) && !b.disableWallets ? (l(), o("label", {
                key: 0,
                class: F(["offset-checkout-payment", { active: d.value === "apple_pay" }])
              }, [
                i(L, {
                  name: "payment",
                  value: "apple_pay",
                  checked: d.value === "apple_pay",
                  onChange: e[13] || (e[13] = (a) => O("apple_pay"))
                }, null, 8, ["checked"]),
                u("div", oa, [
                  i(B, { name: "apple_pay" }),
                  e[26] || (e[26] = u("div", null, "Apple Pay", -1))
                ])
              ], 2)) : c("", !0),
              t(X) && !b.disableWallets ? (l(), o("label", {
                key: 1,
                class: F(["offset-checkout-payment", { active: d.value === "google_pay" }])
              }, [
                i(L, {
                  name: "payment",
                  value: "google_pay",
                  checked: d.value === "google_pay",
                  onChange: e[14] || (e[14] = (a) => O("google_pay"))
                }, null, 8, ["checked"]),
                u("div", da, [
                  i(B, { name: "google_pay" }),
                  e[27] || (e[27] = u("div", null, "Google Pay", -1))
                ])
              ], 2)) : c("", !0),
              (l(!0), o(R, null, Ve(t(w), (a) => (l(), o("label", {
                key: a.id,
                class: F(["offset-checkout-payment", {
                  active: !M.value && t(S) && a.id == t(S).id
                }])
              }, [
                i(L, {
                  name: "payment",
                  value: a.id,
                  checked: !M.value && t(S) && a.id == t(S).id,
                  onChange: (q) => {
                    t(H)(a.id), V(null);
                  }
                }, null, 8, ["value", "checked", "onChange"]),
                u("div", ra, [
                  i(B, {
                    name: t(ve)(a.credit_type)
                  }, null, 8, ["name"]),
                  u("div", null, z(t(pe)(a.credit_number)), 1),
                  u("div", null, z(a.credit_expires_month) + "/" + z(a.credit_expires_year), 1)
                ]),
                i(Je, {
                  onClick: e[15] || (e[15] = K(() => {
                  }, ["stop"]))
                }, {
                  default: h(() => [
                    i(T, {
                      onClick: (q) => Ce(a.id)
                    }, {
                      default: h(() => e[28] || (e[28] = [
                        E("Remove", -1)
                      ])),
                      _: 2,
                      __: [28]
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ], 2))), 128)),
              u("div", va, [
                i(T, {
                  onClick: be,
                  variant: "alt"
                }, {
                  default: h(() => e[29] || (e[29] = [
                    E(" Use a different payment method ", -1)
                  ])),
                  _: 1,
                  __: [29]
                })
              ])
            ], 64))
          ], 64))
        ]),
        _: 1
      }, 8, ["opened", "disabled"])
    ], 512));
  }
}, Ba = /* @__PURE__ */ te(pa, [["__scopeId", "data-v-442a4e6e"]]);
export {
  Ba as C,
  Je as E,
  L as R
};
